import React from 'react';
import { CareTeamSideDrawerForm } from '../../../../../shared/CareTeamForm';
import { useOrganizationId } from '../../../../../../hooks/api/useOrganization';
import useOrganizationCareTeamMembers from '../../../../../../hooks/api/useOrganizationCareTeamMembers';

export type AddCareTeamMemberSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
};

export type AddCareTeamMemberSideDrawerContentProps = AddCareTeamMemberSideDrawerContentOwnProps;

const AddCareTeamMemberSideDrawerContent: React.FC<AddCareTeamMemberSideDrawerContentProps> = ({ onClose }) => {
    const organizationId = useOrganizationId();
    const { createCareTeamMember, isCreatingCareTeamMember } = useOrganizationCareTeamMembers({
        onCreateCareTeamMember: () => onClose(true),
    });
    return (
        <CareTeamSideDrawerForm
            onSubmit={(careTeamMember) =>
                createCareTeamMember({
                    ...careTeamMember,
                })
            }
            isSubmitting={isCreatingCareTeamMember}
            source={{
                source: 'organization',
                organizationId,
            }}
            shouldRecordAddCareTeamMember
            onCancel={() => onClose(true)}
        />
    );
};

export default React.memo(AddCareTeamMemberSideDrawerContent);
